<template>
    <div class="index">
        <div class="header">
            <nav-bar left-arrow :title="$t('提交订单')" />

            <!-- <div style="height: 6vw"></div> -->
            <van-cell class="site_box" is-link>
                <template #title>
                    <div class="addresbox">
                        <div class="img">
                            <img src="~@/assets/img/a30.png" alt="" />
                        </div>
                        <div class="content" v-if="have_address" @click="router('opt_addres')">
                            <span class="tit">{{ address.name }}</span>
                            <span class="num">{{ address.mobile }}</span>
                            <p class="list">{{ address.area.name_path }}-{{ address.detail }}</p>
                        </div>
                        <div class="content" v-else @click="router('add_addres')">
                            <span class="num">{{ $t('暂无收汇地址') }}</span>
                        </div>
                    </div>
                </template>
            </van-cell>
        </div>

        <div class="listbox">

            <div class="item">
                <img class="img" v-lazy="info.img">
                <div>
                    <p class="n one">{{ info.name }}</p>
                    <p class="p one">{{ $t('价值') }}：{{ info.price }}T</p>
                    <p class="one">{{ $t('收益率') }}：{{ info.rate }}%</p>
                    <!-- <p class="one">{{ $t('周期') }}：{{ info.cycle }}</p> -->
                    <p class="one">{{ $t('购买次数') }}：{{ info.buy_count }} /{{ info.limit }}</p>
                </div>
                <!-- <van-button size="mini" :disabled="info.buy_count >= info.limit" round
                        color=" linear-gradient( 90deg, #EBC699 0%, #CD823A 100%)" @click="save(val)">
                        {{ $t('购买') }}</van-button> -->
            </div>
        </div>

        <!-- <div class="password_box">
            <div class="password">
                <van-field :label="$t('交易密码')" clearable v-model="trade_password" type="password"
                    :placeholder="$t('请输入交易密码')" :border="false" maxlength="6" />
            </div>
        </div> -->
        <div-height size="20vw"></div-height>
        <!-- 
        <div-height size="20vw"></div-height> -->

        <div-foot>
            <div-padding padding="3vw">
                <div-btn @click.native="save()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
                    <div-text color='#242424' blod size='4vw'>{{ $t('提交') }}</div-text>
                </div-btn>
            </div-padding>
        </div-foot>

        <van-popup v-model="tipshow" style="width: 80%;" :close-on-click-overlay="false">
            <div class="popupbox">
                <div class="body">
                    <div class="ti">{{ $t('提示') }}</div>
                    <div class="content">
                        <p>{{ tipmsg }}</p>
                        <van-button round color="linear-gradient( 90deg, #EBC699 0%, #CD823A 100%)"
                            @click="tipshow = false">
                            {{ $t('确定') }}</van-button>
                    </div>
                </div>
                <img src="@/assets/img/guanbi@2x.png" alt="" @click="tipshow = false">
            </div>
        </van-popup>

    </div>
</template>

<script>
import { deposit } from "@/utils/index.js"
export default {
    data() {
        return {
            info: {},
            // trade_password: "",
            have_address: false,
            address: '',
            loading: false,
            tipshow: false,
            tipmsg: '',
            account: ''
        };
    },
    created() {
        this.info = this.urlQuery();
        this.get_address();
        this.get_info();
    },
    mounted() {

    },
    methods: {
        get_info() {
            this.$get({
                url: "/api/v1/user/info",
                success: (res) => {
                    // this.usdt = res.data.usdt
                    this.account = res.data.account
                },
                tip: () => { },
            })
        },
        get_address() {
            this.$get({
                url: "/api/v1/memberAddress/list",
                success: (res) => {
                    console.log("地址", res.data.data.length > 0);
                    if (res.data.data.length > 0) {
                        this.have_address = true;
                        this.address = res.data.data[0];
                    } else {
                        this.have_address = false;
                    }
                },
                tip: () => { },
            });
        }, save() {
            if (!this.address) return this.$toast(this.$t("暂无收汇地址"))
            // if (!this.trade_password) return this.$toast(this.$t("请输入交易密码"))
            if (this.loading) return;
            this.$toast.loading({
                duration: 0,
                overlay: true
            })
            this.loading = true
            let that = this
            that.$post({
                url: "/api/v1/user/buy_pre",
                data: {
                    product_id: this.info.id,
                    // trade_password: this.trade_password,
                    address_id: this.address.id
                },
                success: (res) => {
                    console.log("购买前", res)

                    // this.$toast.loading({
                    //     duration: 0,
                    //     overlay: true
                    // })

                    that.$nextTick(() => {
                        console.log("1", that.address)
                        // that.blockFun
                        //     .transfer("usdt", String(that.info.usdt_price), that.address, "ether", false)
                        //     .then((hash) => { that.payOrder(hash) }).catch((err) => {
                        //         that.loading = false
                        //         that.$toast.fail(that.$t(err.msg))
                        //     })

                        // that.payOrder(123132);
                        // return

                        that.blockFun.getEthBalance("bnb").then(res => {
                            console.warn('balance', res);
                            if (Number(res) < Number(that.info.usdt_price)) {
                                that.$toast.fail(that.$t('余额不足'))
                                // that.$toast.clear()
                                that.loading = false
                            } else {
                                deposit(that.account, that.info.usdt_price).then(res => {
                                    // res.hash是hash
                                    console.warn('hash是', res);
                                    if (res.hash) {

                                        that.payOrder(res.hash)
                                    } else {
                                        that.$toast.fail(that.$t(err.msg))
                                        that.loading = false
                                    }
                                }).catch(err => {
                                    console.log('报错2', err)
                                    that.loading = false
                                    that.$toast.clear()
                                    that.bloading = false
                                    that.tipmsg = that.$t("支付失败")
                                    that.tipshow = true

                                })
                            }
                        }).catch(err => {
                            console.log('报错1', err)
                            that.loading = false
                            that.$toast.clear()
                            that.bloading = false
                            that.tipmsg = that.$t("支付失败")
                            that.tipshow = true
                        })

                    })
                },
                tips: (err) => {
                    this.loading = false
                    this.$toast.clear()
                    this.bloading = false
                    this.tipmsg = err.message
                    this.tipshow = true
                },
            })

        }, payOrder(hash) {


            // this.$toast.loading({
            //     duration: 0,
            //     overlay: true
            // })

            this.$post({
                url: "/api/v1/user/buy_machine",
                data: {
                    product_id: this.info.id,
                    // trade_password: this.trade_password,
                    hash,
                    status: 4,
                    address_id: this.address.id
                },
                success: (res) => {
                    console.log("支付成功", res)
                    this.loading = false
                    this.$toast({
                        message: this.$t('成功'),
                        onClose: () => {
                            this.goBack()
                        }
                    })
                },
                tips: (err) => {
                    this.loading = false
                    this.$toast.clear()
                    this.bloading = false
                    this.tipmsg = err.message
                    this.tipshow = true
                },
            })
        }
    },
};
</script>

<style scoped lang="less">
.listbox {
    width: 100%;
    padding: 3vw;

    .item {
        width: 100%;
        background: #1A1C1D;
        border-radius: 6px;
        padding: 3vw;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        img {
            border-radius: 1vw;
            width: 110px;
            height: 110px;
            display: block;
            margin-right: 3vw;
        }


        >p {
            width: 100%;
            line-height: 1.6;
            color: #C7C7CC;
            font-size: 12px;
        }

        .n {
            color: #FFFFFF;
            font-size: 17px;
            font-weight: 550;
        }

        .p {
            color: #E6B17F;
            padding: 2px 0 0;
        }

        /deep/.van-button {
            width: 90%;
            padding: 14px 10px;
            margin-top: 10px;

            .van-button__text {
                color: #fff;
                font-size: 14px;
            }
        }
    }
}


//大盒子
.index {
    width: 100vw;
    min-height: 100vh;
    height: auto;
    box-sizing: border-box;
    // background: #fff;

    /deep/.van-nav-bar {
        .van-icon {
            color: #303133;
        }
    }

    //顶部背景图
    .header {
        width: 100%;

        //地址部分
        .site_box {
            width: 100%;
            padding: 6vw 3vw;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            background: #1A1C1D;
            width: 92.53vw;
            box-shadow: 0vw 1.33vw 2.67vw 0vw rgba(0, 0, 0, 0.1);
            border-radius: 2.67vw;
            margin: 0 auto;
            margin-top: 3vw;

            .addresbox {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .img {
                    width: 30px;
                    height: 30px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .content {
                    flex: 1;
                    padding: 0 3vw;
                    display: flex;
                    flex: 1;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    align-items: flex-start;

                    .tit {
                        font-size: 4.8vw;
                        color: #fff;
                        font-weight: bold;
                        margin-right: 3vw;
                    }

                    .num {
                        font-size: 3.5vw;
                        color: #fff;
                        line-height: 7.6vw;
                    }

                    .list {
                        width: 100%;
                        font-size: 3.5vw;
                        color: #fff;
                        line-height: 6.6vw;
                    }
                }
            }
        }
    }


    /deep/.van-cell-group {

        .van-cell {
            width: 100%;
            padding: 20px;
            background: #1A1C1D;
            box-shadow: 0vw 1.33vw 2.67vw 0vw rgba(0, 0, 0, 0.1);
            border-radius: 2.67vw;
            margin: 3vw auto;

            .van-cell__left-icon {
                font-size: 36px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 20px;
            }

            .van-cell__title {
                color: #333333;
                font-size: 28px;
            }
        }
    }

    //底部提交订单样式
    /deep/.van-submit-bar {
        width: 100%;

        .van-submit-bar__bar {
            padding: 0 0 0 20px;

            .van-submit-bar__text {
                color: #000000;
                font-size: 28px;

                .van-submit-bar__price {
                    color: #ea3501;
                    font-size: 32px;
                    font-weight: 550;
                }
            }

            .van-button {
                height: 100%;
                border-radius: 0;
                background: linear-gradient(270deg, #ea3501 0%, #fe7729 100%);
            }
        }
    }
}

//单元格样式
/deep/.van-cell {
    width: 92.53vw;
    display: block;
    // box-shadow: 0vw 0vw 4.27vw 0vw rgba(96, 98, 102, 0.08);

    border-radius: 2.13vw;
    padding: 0 16px;
    // margin: 3.73vw;
}

/deep/.van-field__label {
    font-size: 3.5vw !important;
    color: #fff;
    line-height: 12.8vw;
}

/deep/.van-field__control {
    font-size: 3.5vw !important;
    color: #fff;
    padding-bottom: 4vw;
}

// .password_box {
//     padding: 0 3vw 3vw 3vw;

//     .password {
//         background: #1A1C1D;
//     }
// }


/deep/.van-popup {
    background: none;

    .popupbox {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .body {
            width: 100%;
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            margin-bottom: 20px;

            .ti {
                width: 100%;
                background: linear-gradient(90deg, #EBC699 0%, #CD823A 100%);
                padding: 11px 0;
                color: #fff;
                font-size: 18px;
                text-align: center;
            }

            .content {
                width: 100%;
                padding: 25px 20px 48px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                >p {
                    color: #333333;
                    font-size: 14px;
                    margin-bottom: 35px;
                }

                .van-button {
                    width: 60%;
                    padding: 14px 10px;

                    .van-button__text {
                        color: #fff;
                        font-size: 14px;
                    }
                }
            }
        }

        img {
            width: 50px;
            height: 50px;
        }
    }
}

.inp {
    width: 100%;
    padding: 30px 20px;

    /deep/.van-cell {
        border: 1px solid #ccc;
        padding: 13px 10px;

        .van-field__control {
            color: #fff;
        }
    }
}
</style>